class PageBuilder
{
	/** @type {FroalaEditor} */
	editor;
	editableElementSelector;

	constructor()
	{

	}

	init(editableElementSelector, froalaConfig)
	{
		const _this = this;
		$(function ()
		{ 
			_this._initEditor(editableElementSelector, froalaConfig);
			$(`.actions-container .primary-action-button`).on("click", function (e)
			{
				_this._save(e, 'saveAndExit');
			});
			$('.actions-container .secondary-action-button').on("click", function (e)
			{
				_this._save(e, 'save');
			});
		});
	}

	_save(e, action)
	{

		$('input[name="form[content]"]').val(this.editor.codeView.isActive() ? this.editor.codeView.get() : this.editor.html.get());
		$('input[name="action"]').val(action);
		$('form')[0].submit();
	}

	_initEditor(editableElementSelector, froalaConfig)
	{
		const _this = this;

		if (froalaConfig.events === undefined) {
			froalaConfig.events = {};
		}
		froalaConfig.events['html.get'] = (html) => { return _this._cleanHtmlBeforeSave(html) };
		froalaConfig.events['initialized'] = () => _this._addEditableAttributes();
		froalaConfig.events['template.inserted'] = () => _this._addEditableAttributes();
		this.editor = new FroalaEditor($(editableElementSelector)[0], froalaConfig);
		this.editableElementSelector = editableElementSelector;
	}

	_addEditableAttributes()
	{
		$(`${this.editableElementSelector} .ct-editable`).attr('contentEditable', true);
		$(`${this.editableElementSelector} .ct-non-editable`).attr('contentEditable', false);
	}
	/** @param {string} html */
	_cleanHtmlBeforeSave(html)
	{
		return html.replace(/\s+contenteditable="(true|false)"/gi, "");
	}
}